import * as moment from 'moment';
import { SearchRecord } from '../packages-module/models/searchPackage';

export class ScreeningFilter {
  clientName : string; //no - client object
  clientId : number; 
  locationName : string; //no - location object
  locationId : number;
  invitationId : number;
  userName : string; //no - user object
  userEmail : string; //no - user object
  orderDateFrom : Date; //no - needs to be invitationDate
  orderDateTo : Date; //no - needs to be invitationDate
  reportStatus : string; //no - screening object
  applicantFirstName : string;
  applicantLastName : string;
  applicantSSN : string; //no - screening object
  applicantDOB : string; //no - screening object
  applicantEmail : string; //no - update to invitedParty
  released: boolean;
  _orderDateFromMoment : moment.Moment; // 
  _orderDateToMoment : moment.Moment;
  
  public set orderDateFromMoment(v : moment.Moment) {
    this._orderDateFromMoment = v;
    this.orderDateFrom = this._orderDateFromMoment.toDate();
  }
  
  public get orderDateFromMoment() : moment.Moment {
    return this._orderDateFromMoment
  }
  
  public get orderDateToMoment() : moment.Moment {
    return this._orderDateToMoment;
  }
  
  public set orderDateToMoment(v : moment.Moment) {
    this._orderDateToMoment = v;
    this.orderDateTo = this._orderDateToMoment.toDate();
  }
  
  manualProcessing : boolean;
}

export class StandAloneFilter {
  public get searchType() : number {
    return this.filterVal?.searchType;
  }

  public get searchDepth() : number {
    return this.filterVal?.searchMeta?.searchDepth;
  }
     
  filterVal : SearchRecord;
}

export class SearchAndPipeFilter {
  searchType : number;
  pipelineStage : number;
}

export enum OrderByDesignator { 
    Ascending = 0,
    Descending = 1
}

export class ScreeningOrderByContract {
    orderByColumn: string;
    designator: OrderByDesignator;

}

export class ScreeningFilteredListRequestModels {
    filters: ScreeningFilter;
    orderBy: ScreeningOrderByContract;
    standAloneFilter: StandAloneFilter;
}